/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MessagesCountsRequest = {
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
};

/** @internal */
export const GetApiV3MessagesCountsRequest$inboundSchema: z.ZodType<
  GetApiV3MessagesCountsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  subnet: z.nullable(z.string()).default(null),
});

/** @internal */
export type GetApiV3MessagesCountsRequest$Outbound = {
  subnet: string | null;
};

/** @internal */
export const GetApiV3MessagesCountsRequest$outboundSchema: z.ZodType<
  GetApiV3MessagesCountsRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MessagesCountsRequest
> = z.object({
  subnet: z.nullable(z.string()).default(null),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MessagesCountsRequest$ {
  /** @deprecated use `GetApiV3MessagesCountsRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MessagesCountsRequest$inboundSchema;
  /** @deprecated use `GetApiV3MessagesCountsRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MessagesCountsRequest$outboundSchema;
  /** @deprecated use `GetApiV3MessagesCountsRequest$Outbound` instead. */
  export type Outbound = GetApiV3MessagesCountsRequest$Outbound;
}

export function getApiV3MessagesCountsRequestToJSON(
  getApiV3MessagesCountsRequest: GetApiV3MessagesCountsRequest,
): string {
  return JSON.stringify(
    GetApiV3MessagesCountsRequest$outboundSchema.parse(
      getApiV3MessagesCountsRequest,
    ),
  );
}

export function getApiV3MessagesCountsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MessagesCountsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3MessagesCountsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MessagesCountsRequest' from JSON`,
  );
}
